import useApi from "@verivest/shared-components/src/api/hooks/useApi";
export { AuthContext } from "@verivest/shared-components";

export default useApi;
